<template>
  <div :class="$style.wrapper">
<!--    <div>-->
<!--      <router-link to="/">home</router-link>-->
<!--      <br>-->
<!--      <router-link to="/another">another</router-link>-->
<!--    </div>-->
    <slot />
  </div>
</template>
<script>
export default {
  name: 'DefaultLayout',
}
</script>
<style lang="scss" module>
@import './DefaultLayout.scss';
</style>
